/* Silvano — comportamentos globais do tema (wishlist + reveal-on-scroll).
   Sem dependências. Progressive enhancement. */
(function () {
  'use strict';

  /* ----------------------------------------------------------- Wishlist */
  var KEY = 'sv_wishlist';
  var EVENT = 'sv:wishlist'; /* espelha o CustomEvent 'ss:wishlist' do headless */
  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage cheio/bloqueado — ignora */
    }
    /* única fonte de verdade: quem mudou avisa, quem mostra repinta */
    window.dispatchEvent(new CustomEvent(EVENT));
  }
  function has(handle) {
    return read().indexOf(handle) !== -1;
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.push(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    return i === -1; // true = agora salvo
  }
  function clear() {
    write([]);
  }
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-sv-wish-count]').forEach(function (el) {
      el.textContent = n > 9 ? '9+' : n;
      el.hidden = n === 0;
    });
  }
  function paintButtons() {
    document.querySelectorAll('[data-sv-wish]').forEach(function (btn) {
      paintButton(btn, has(btn.dataset.handle));
    });
  }
  /* estado visual + a11y sempre juntos — senão o aria-pressed do card fica velho */
  function paintButton(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var t = btn.dataset.title;
    if (t) {
      btn.setAttribute(
        'aria-label',
        (active ? 'Remover ' + t + ' da' : 'Adicionar ' + t + ' à') + ' lista de desejos'
      );
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sv-wish]');
    if (!btn) return;
    e.preventDefault();
    var active = toggle(btn.dataset.handle);
    paintButton(btn, active);
    if (btn.dataset.labelOn && btn.dataset.labelOff) {
      var lbl = btn.querySelector('[data-sv-wish-label]');
      if (lbl) lbl.textContent = active ? btn.dataset.labelOn : btn.dataset.labelOff;
    }
  });

  /* mesma aba (CustomEvent) + outras abas (storage) — badge e página nunca divergem */
  window.addEventListener(EVENT, function () {
    paintCount();
    paintButtons();
  });
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === KEY) {
      paintCount();
      paintButtons();
    }
  });

  /* ------------------------------------------------- Reveal on scroll */
  function initReveal() {
    /* Dois alvos: grupos (escalonam os filhos por --i) e .sv-reveal soltos.
       Um .sv-reveal DENTRO de um grupo não é observado sozinho — senão ele
       entraria pelo próprio scroll e o stagger do grupo nunca apareceria. */
    var groups = [].slice.call(document.querySelectorAll('.sv-reveal-group'));
    var loose = [].slice.call(document.querySelectorAll('.sv-reveal')).filter(function (el) {
      return !el.closest('.sv-reveal-group');
    });
    var els = groups.concat(loose);
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* --------------------------------- Scroll (overlay/compact do header) */
  /* Histerese igual ao useScrolled(90,24) do headless: liga em >90, desliga
     só em <24 (zona morta evita flicker quando a topbar colapsa ~34px). */
  function initScroll() {
    var root = document.documentElement;
    var scrolled = false;
    function onScroll() {
      var y = window.pageYOffset || root.scrollTop || 0;
      if (!scrolled && y > 60) {
        scrolled = true;
        root.classList.add('sv-scrolled');
      } else if (scrolled && y < 16) {
        scrolled = false;
        root.classList.remove('sv-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    paintButtons();
    paintCount();
    initReveal();
    initScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.SilvanoWishlist = { read: read, has: has, toggle: toggle, clear: clear };
})();
